import React from "react";
import { useProductionStore } from "../../../stores/production";

const TimeByCollab = () => {
  const { production } = useProductionStore();

  const months = production?.[0]?.missions?.[0]?.months ? Object.keys(production[0].missions[0].months) : [];

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl">
      {production?.map((row: any) => (
        <React.Fragment key={row.id}>    
          <thead className="mt-5">
              <React.Fragment key={row.id}>
                <tr className="h-12">
                  <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-80">
                    {row.name}
                  </th>
                  {months?.map((month: any) => (
                    <th key={month} className="border border-gray-300 px-4 py-2 bg-thead text-left w-24">
                      {month}
                    </th>
                  ))}
                  <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-24">
                    Total
                  </th>
                </tr>
              </React.Fragment>
          </thead>
          <tbody>
              <React.Fragment key={row.id}>
                {row.missions?.map((mission: any) => (
                  <tr key={mission.id}>
                    <td className="border border-gray-300 px-4 py-2 text-left w-80">
                      {mission.name}
                    </td>
                    {months?.map((month: any) => (
                      <td key={month} className="border border-gray-300 px-4 py-2 text-left w-24">
                        {mission.months[month] == 0
                              ? ""
                              : mission.months[month]}
                      </td>
                    ))}
                    <td className="border border-gray-300 px-4 py-2 text-left w-24 bg-gray-100">
                      {months?.reduce((total: number, month: string) => total + (mission.months[month] || 0), 0)}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
          </tbody>
        </React.Fragment>
      ))}
    </table>
  )
}

export default TimeByCollab;